import { generateKeys } from '../utils';
export const appointmentCategories = generateKeys({
    upSell: {
        value: 'upSell',
        label: 'Up-Sell',
        department: 'sales',
    },
    oneOnOne: {
        value: 'oneOnOne',
        label: 'One on One',
        department: 'sales',
    },
    retain: {
        value: 'retain',
        label: 'Retain',
        department: 'sales',
    },
    webinarCall: {
        value: 'webinarCall',
        label: 'Webinar Call',
        department: 'sales',
    },
    newsCall: {
        value: 'newsCall',
        label: 'News Call',
        department: 'sales',
    },
    callAgain: {
        value: 'callAgain',
        label: 'Call Again',
        department: 'sales',
    },
    upSellF: {
        value: 'upSellF',
        label: 'Up-Sell F',
        department: 'sales',
    },
    followUp: {
        value: 'followUp',
        label: 'Follow up',
        department: 'sales',
    },
    qualify: {
        value: 'qualify',
        label: 'Qualify',
        department: 'sales',
    },
    customReminder: {
        value: 'customReminder',
        label: 'Custom Reminder',
        department: 'sales',
    },
    appointment: {
        value: 'appointment',
        label: 'Appointment',
        department: 'boAccountOpening',
    },
    callBackBackOffice: {
        value: 'callBackBackOffice',
        label: 'Call Back',
        department: 'boAccountOpening',
    },
    complaintFollowUp: {
        value: 'complaintFollowUp',
        label: 'Complaint Follow Up',
        department: 'boAccountOpening',
    },
    closureOfAccount: {
        value: 'closureOfAccount',
        label: 'Closure of Account ',
        department: 'boAccountOpening',
    },
    dealingBackOffice: {
        value: 'dealingBackOffice',
        label: 'Dealing ',
        department: 'boFunding',
    },
    closePositions: {
        value: 'closePositions',
        label: 'Close Positions',
        department: 'boFunding',
        parentCategory: 'dealingBackOffice',
    },
    documents: {
        value: 'documents',
        label: 'Documents',
        department: 'boAccountOpening',
    },
    proofOfIdentity: {
        value: 'proofOfIdentity',
        label: 'Proof of Identity',
        department: 'boAccountOpening',
        parentCategory: 'documents',
    },
    proofOfIncome: {
        value: 'proofOfIncome',
        label: 'Proof of Income',
        department: 'boFunding',
        parentCategory: 'documents',
    },
    proofOfResidence: {
        value: 'proofOfResidence',
        label: 'Proof of Residence',
        department: 'boAccountOpening',
        parentCategory: 'documents',
    },
    customReminderBackOffice: {
        value: 'customReminderBackOffice',
        label: 'Сustom Reminder',
        department: 'boFunding',
    },
    callBackSupport: {
        value: 'callbackSupport',
        label: 'Сall Back',
        department: 'support',
    },
    funding: {
        value: 'funding',
        label: 'Funding',
        department: 'support',
        parentCategory: 'callBackSupport',
    },
    verification: {
        value: 'verification',
        label: 'Verification',
        department: 'support',
        parentCategory: 'callBackSupport',
    },
    dealingSupport: {
        value: 'dealingSupport',
        label: 'Dealing',
        department: 'support',
        parentCategory: 'callBackSupport',
    },
    production: {
        value: 'production',
        label: 'Production',
        department: 'support',
        parentCategory: 'callBackSupport',
    },
    product: {
        value: 'product',
        label: 'Product',
        department: 'support',
        parentCategory: 'callBackSupport',
    },
    trading: {
        value: 'trading',
        label: 'Trading',
        department: 'support',
        parentCategory: 'callBackSupport',
    },
    other: {
        value: 'other',
        label: 'Other',
        department: 'sales',
    },
});
export const appointmentColors = generateKeys({
    tomato: {
        value: 'tomato',
        label: 'Tomato',
        hex: '#d50000',
        colorId: 11,
    },
    flamingo: {
        value: 'flamingo',
        label: 'Flamingo',
        hex: '#e67c73',
        colorId: 4,
    },
    tangerine: {
        value: 'tangerine',
        label: 'Tangerine',
        hex: '#f4511e',
        colorId: 6,
    },
    banana: {
        value: 'banana',
        label: 'Banana',
        hex: '#f6bf26',
        colorId: 5,
    },
    sage: {
        value: 'sage',
        label: 'Sage',
        hex: '#33b679',
        colorId: 2,
    },
    basil: {
        value: 'basil',
        label: 'Basil',
        hex: '#0b8043',
        colorId: 10,
    },
    peacock: {
        value: 'peacock',
        label: 'Peacock',
        hex: '#039be5',
        colorId: 7,
    },
    blueberry: {
        value: 'blueberry',
        label: 'Blueberry',
        hex: '#3f51b5',
        colorId: 9,
    },
    lavender: {
        value: 'lavender',
        label: 'Lavender',
        hex: '#7986cb',
        colorId: 1,
    },
    grape: {
        value: 'grape',
        label: 'Grape',
        hex: '#8e24aa',
        colorId: 3,
    },
    graphite: {
        value: 'graphite',
        label: 'Graphite',
        hex: '#616161',
        colorId: 8,
    },
});
